import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_deliverySelf} from "../../../function/FnBodyLayer";

@observer
class SettingDefaultSelfDeliveryItemView extends Component {
    render() {
        const { rootStore , obj} = this.props;
        let retire = "";
        switch(obj.retire_fg){
            case "0":
                retire = "재직";
                break;
            case "1":
                retire = "퇴직";
                break;
            case "2":
                retire = "휴직";
                break;
        }
        return(
            <li>
                <div className="item">
                    <div className="tit">{obj.emp_nm}</div>
                    <div className="status">{retire}</div>
                    <div className="btn">
                        <button onClick={event => fn_deliverySelf(rootStore, obj)}><span></span></button>
                    </div>
                </div>
            </li>
        )
    }
}

export default SettingDefaultSelfDeliveryItemView;